import _ from 'lodash';
//import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import FMPHeadline from '../../components/ui/FMPHeadline';
import OcrGuideContainer from '../../containers/ocr/OcrGuides';
import ResourcePopup from '../../components/Dialogs/ResourcePopup';
//import PricingPopupIcon from "../../images/icons/pricingPopup.svg";
//import documentIcon from "../../images/document.svg";

import { getSharedStyles } from '../../themes';
import EnhancedTable from '../../components/table/EnhancedTable';
import Button from '@material-ui/core/Button';
const styles = (theme) => ({
	...getSharedStyles(theme),
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	docContainer: {
		position: 'absolute',
	},
});

const ocrColumns = [
	{
		sortId: 'ocrGuideId',
		displayId: 'ocrGuideId',
		labels: ['Schema ID'],
	},
	{
		sortId: 'accountingCategory',
		displayId: 'accountingCategory',
		labels: ['Accounting', 'Category'],
	},
	{
		sortId: 'documentCategory',
		displayId: 'documentCategory',
		labels: ['Document', 'Category'],
	},
	{
		sortId: 'vendorDisplay',
		displayId: 'vendorDisplay',
		label: 'Vendor',
	},
	{
		sortId: 'detectionIndicatorBlockCount',
		displayId: 'detectionIndicatorBlockCount',
		label: 'Detection Blocks',
	},
	{
		sortId: 'deliveryMatchingBlockCount',
		displayId: 'deliveryMatchingBlockCount',
		label: 'Delivery Match Blocks',
	},
	{
		sortId: 'invoiceDataBlockCount',
		displayId: 'invoiceDataBlockCount',
		label: 'Invoice Data Blocks',
	},
	{
		sortId: 'startDate',
		displayId: 'dateCreatedFormatted',
		label: 'Date Created',
	},
	{
		sortId: 'documentInfo',
		displayId: 'documentDisplay',
		label: 'Documents',
	},
	{
		sortId: 'edit',
		displayId: 'editButtons',
		label: 'Edit',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
];

class OcrGuides extends Component {
	constructor(props) {
		super(props);

		const startingTab = _.get(this.props, ['match', 'params', 'startingTab'], 'current');
		const startingTabIndex = { current: 0, upcoming: 1, completed: 2 }[startingTab] || 0;

		this.state = {
			tabIndex: startingTabIndex,
			order: 'desc',
			orderBy: 'ocrGuideId',
			search: '',
			filterMap: {},
			isViewDialogOpen: false,
			isResourcePopupOpen: false,
			resourceIdsPoppedUp: [],
			isPricingPoppedUp: false,
			ocrGuidePoppedUp: undefined,

			upcomingRows: undefined,
			currentRows: undefined,
			completedRows: undefined,
		};
	}

	componentDidMount() {
		const { ocrGuideSearch } = this.props;
		ocrGuideSearch();
	}

	componentDidUpdate(prevProps) {
		const { ocrGuides } = this.props;
		if (prevProps.ocrGuides !== ocrGuides) {
			this.formatOcrGuides();
		}
	}

	formatOcrGuides = () => {
		const { classes } = this.props;
		const { ocrGuides, carrierMap, supplierMap, terminalMap } = this.props;
		const formattedOcrGuides = [];
		ocrGuides.forEach((ocrGuide) => {
			const {
				ocrGuideId,
				carrierId,
				terminalId,
				supplierId,
				detectionIndicatorBlocks,
				deliveryMatchingBlocks,
				invoiceDataBlocks,
				dateCreated,
			} = ocrGuide;
			const carrier = carrierMap[carrierId] || { name: 'Missing' };
			const supplier = supplierMap[supplierId] || { name: 'Multiple Suppliers' };
			const terminal = terminalMap[terminalId] || { name: 'Missing' };

			ocrGuide.key = ocrGuideId;
			if (carrierId) {
				ocrGuide.vendorDisplay = `Carrier : ${carrier.name}`;
			} else {
				ocrGuide.vendorDisplay = `Term/Supplier : ${terminal.name} & ${supplier.name}`;
			}

			ocrGuide.dateCreatedFormatted = (
				<div>
					<div>{moment(dateCreated).format('M/D/YYYY')}</div>
				</div>
			);

			ocrGuide.detectionIndicatorBlockCount = detectionIndicatorBlocks.length;
			ocrGuide.deliveryMatchingBlockCount = deliveryMatchingBlocks.length;
			ocrGuide.invoiceDataBlockCount = invoiceDataBlocks.length;

			/*

			if (_.isEmpty(resourceIds)) {
				ocrGuide.documentDisplay = '-';
			} else {
				let left = 0;
				let zIndex = 100;
				ocrGuide.documentDisplay = (
					<div
						onClick={() => {
							this.handleResourcesClick({ resourceIds });
						}}
						style={{position : 'relative', height : 40, width : 40}}>
						{resourceIds.map((resourceId, i) => {
							left = i * 10;
							zIndex--;
							return (
								<div className={classes.docContainer} style={{left, zIndex}} key={resourceId}>
									<div className={classes.documentIcon}/>
								</div>
							);
						})}
					</div>
				);
			}
			 */

			ocrGuide.editButtons = (
				<Button className={classes.button} onClick={() => this.handleEdit(ocrGuideId)}>
					Edit
				</Button>
			);
			formattedOcrGuides.push(ocrGuide);
		});
		this.setState({ formattedOcrGuides });
	};

	handleSearch = (event) => {
		this.setState({ search: event.target.value });
	};

	handleEdit = (ocrGuideId) => {
		this.props.history.push(`/ocr/ocrGuide/update/${ocrGuideId}`);
	};

	handleRowClick = (ocrGuideId) => {
		const { ocrGuides } = this.props;
		const viewFuelContract = _.find(ocrGuides, { ocrGuideId });
		this.setState({
			viewFuelContract,
			isViewDialogOpen: true,
		});
	};

	handleCloseViewDialog = () => {
		this.setState({
			isViewDialogOpen: false,
			viewFuelContract: undefined,
		});
	};

	handleCloseResourcePopup = () => {
		this.setState({
			isResourcePopupOpen: false,
			resourceIdsPoppedUp: [],
		});
	};

	/*
	handleResourcesClick = ({ resourceIds }) => {
		this.setState({
			isResourcePopupOpen : true,
			resourceIdsPoppedUp : resourceIds,
		});
	};
	 */

	render() {
		const { classes, resourceMap, authUser } = this.props;

		const canMakeUpdates = _.get(authUser, ['permissions', 'canMakeUpdates']);
		const { formattedOcrGuides, order, orderBy } = this.state;

		if (!formattedOcrGuides) {
			return <div>Loading the ocr guides...</div>;
		}

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<FMPHeadline
						label="OCR Document Schemas"
						value={this.state.search}
						onChange={this.handleSearch}
						buttonText="Add New OCR Schema"
						url="/ocr/ocrGuide/add"
						canMakeUpdates={!!canMakeUpdates}
					/>
					<Paper className={classes.paper}>
						<EnhancedTable
							columns={ocrColumns}
							rows={formattedOcrGuides}
							defaultOrder={order}
							defaultOrderBy={orderBy}
						/>

						<ResourcePopup
							open={this.state.isResourcePopupOpen}
							onClose={this.handleCloseResourcePopup}
							resourceIds={this.state.resourceIdsPoppedUp}
							resourceMap={resourceMap}
						/>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

OcrGuides.propTypes = {
	classes: PropTypes.object.isRequired,
	ocrGuideSearch: PropTypes.func.isRequired,
	ocrGuides: PropTypes.array,

	showErrors: PropTypes.func.isRequired,

	carrierMap: PropTypes.object,
	supplierMap: PropTypes.object,
	terminalMap: PropTypes.object,
	resourceMap: PropTypes.object,

	history: PropTypes.object,
	theme: PropTypes.object.isRequired,

	authUser: PropTypes.object,
};

export default _.flow([withStyles(styles, { withTheme: true }), OcrGuideContainer])(OcrGuides);
